<style scoped>

</style>
<template>
  <div class="text-center">
    <div class="line">
      <DatePicker
        type="daterange"
        :options="date_option"
        placeholder="选择付款申请日期"
        style="width: 200px"
        @on-change="daterangeChange"
      />
      <Button
        type="primary"
        @click="exportInvoice"
      >
        导出
      </Button>
    </div>
  </div>
</template>
<script route="/invoice/export">
  export default {
    /* router_info_start */
    router_info: '/invoice/export',
    /* router_info_end */

    data() {
      return {
        params: {
          daterange: []
        },
        date_option: {
          shortcuts: [
            {
              text: '最近一周',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                return [start, end];
              }
            },
            {
              text: '最近一个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                return [start, end];
              }
            },
            {
              text: '最近三个月',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                return [start, end];
              }
            },
            {
              text: '最近一年',
              value() {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                return [start, end];
              }
            }
          ]
        }
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      daterangeChange(daterange) {
        this.params.daterange = daterange;
      },
      exportInvoice() {
        if (this.params.daterange.length === 0) {
          this.$Message.error({title: '提示', content: '请选择日期'});
          return;
        }
        window.open(Util.api.export_invoice + '.xlsx?' + Util.urlEncode(this.params), '_blank');
      },
      test() {
        Util.ajax.get('api_url', {
          params: {
            //
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            //成功
          } else {
            //失败
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          console.log(e);
          this.$Modal.warning({title: '错误', content: e.message});
        }).then(function() {
          // always executed
        });
      }
    }
  }
</script>
